/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Not_EnrolledInputs */



/**
* | output |
* | --- |
* | "No authenticator devices are set up. You can still sign in using your recovery code." |
*
* @param {Profile_Security_Totp_Not_EnrolledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_not_enrolled = /** @type {((inputs?: Profile_Security_Totp_Not_EnrolledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Not_EnrolledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine Authenticator-Geräte eingerichtet. Du kannst dich weiterhin mit deinem Wiederherstellungscode anmelden.")
	return /** @type {LocalizedString} */ ("No authenticator devices are set up. You can still sign in using your recovery code.")
});